import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { ImportRecord } from '../types';

export const useImportedUsers = () => {
  return useQuery({
    queryKey: ['user-imports'],
    queryFn: async () => {
      // Check if user is authenticated
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      
      if (!user) {
        throw new Error('User not authenticated');
      }

      // First get user imports
      const { data: imports, error: importsError } = await supabase
        .from('user_imports')
        .select('*')
        .order('created_at', { ascending: false });
      
      if (importsError) {
        console.error('Imports query error:', importsError);
        throw importsError;
      }
      
      if (!imports) return [];

      // Get invitation data for each email
      const emails = imports.map(record => record.email);
      const { data: invitations } = await supabase
        .from('invitations')
        .select('email, status, expires_at, updated_at')
        .in('email', emails);
      
      // Create a map of email to invitation data
      const invitationMap = new Map();
      invitations?.forEach(invitation => {
        if (!invitationMap.has(invitation.email)) {
          invitationMap.set(invitation.email, invitation);
        }
      });
      
      // Transform the data to include invitation info
      const transformedData = imports.map(record => {
        const invitation = invitationMap.get(record.email);
        return {
          ...record,
          invitation_status: invitation?.status || 'none',
          invitation_expires_at: invitation?.expires_at,
          last_invitation_sent: invitation?.updated_at
        };
      });
      
      return transformedData as ImportRecord[];
    },
    retry: 3,
    retryDelay: 1000,
  });
};